import React from "react";
import { Link } from "react-router-dom";
import "./styles.css";

const ContentCard = ({ title, description, link, ctaLabel = "View" }) => {
  const isExternal = /^https?:\/\//i.test(link);

  const content = (
    <>
      <h3 className="content-card__title">{title}</h3>
      <p className="content-card__description">{description}</p>
      <span className="content-card__cta">{ctaLabel} →</span>
    </>
  );

  if (isExternal) {
    return (
      <a
        className="content-card"
        href={link}
        target="_blank"
        rel="noopener noreferrer"
      >
        {content}
      </a>
    );
  }

  return (
    <Link className="content-card" to={link}>
      {content}
    </Link>
  );
};

export default ContentCard;
